/**
 * Script-tag build. Exposes window.CoBrowse and self-initialises from data attributes, so a
 * server-rendered application needs no bundler and no JavaScript of its own:
 *
 *   <script src=".../cobrowse.global.js" data-tenant="fingpay"
 *           data-token-url="/api/cobrowse/token"
 *           data-mask-selectors="[data-pii],.vpa" defer></script>
 */
import { CoBrowse } from "./index.js";
import type { CoBrowseConfig } from "./types.js";

declare global { interface Window { CoBrowse: typeof CoBrowse & { instance?: unknown } } }
window.CoBrowse = CoBrowse as typeof CoBrowse & { instance?: unknown };

const el = document.currentScript as HTMLScriptElement | null;
const tenant = el?.dataset.tenant;
if (el && tenant) {
  const list = (v?: string) => (v ? v.split(",").map((s) => s.trim()).filter(Boolean) : undefined);
  const tokenUrl = el.dataset.tokenUrl;
  const cfg: CoBrowseConfig = {
    tenant,
    endpoint: el.dataset.endpoint,
    region: el.dataset.region,
    sessionToken: tokenUrl
      ? async () => (await (await fetch(tokenUrl, { credentials: "same-origin" })).json()).token
      : undefined,
    privacy: {
      maskSelectors: list(el.dataset.maskSelectors),
      maskInputTypes: list(el.dataset.maskInputTypes),
      excludeRegions: list(el.dataset.excludeRegions),
    },
    debug: el.dataset.debug === "true",
  };
  void CoBrowse.init(cfg).then((h) => { window.CoBrowse.instance = h; });
}
